import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgList = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.03003 9.52002C3.03003 9.80002 3.25003 10.02 3.53003 10.02H7.53003C7.81003 10.02 8.03003 9.80002 8.03003 9.52002V5.52002C8.03003 5.24002 7.81003 5.02002 7.53003 5.02002H3.53003C3.25003 5.02002 3.03003 5.24002 3.03003 5.52002V9.52002ZM7.03003 9.02002H4.03003V6.02002H7.03003V9.02002Z'
    />
    <path d='M21 7.5C21 7.78 20.78 8 20.5 8H10.5C10.22 8 10 7.78 10 7.5C10 7.22 10.22 7 10.5 7H20.5C20.78 7 21 7.22 21 7.5Z' />
    <path d='M10 16.5C10 16.78 10.22 17 10.5 17H20.5C20.78 17 21 16.78 21 16.5C21 16.22 20.78 16 20.5 16H10.5C10.22 16 10 16.22 10 16.5Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.03003 18.46C8.03003 18.74 7.81003 18.96 7.53003 18.96H3.53003C3.25003 18.96 3.03003 18.74 3.03003 18.46V14.46C3.03003 14.18 3.25003 13.96 3.53003 13.96H7.53003C7.81003 13.96 8.03003 14.18 8.03003 14.46V18.46ZM4.03003 17.96H7.03003V14.96H4.03003V17.96Z'
    />
  </svg>
);
export default SvgList;
